module.exports = __webpack_public_path__ + "img/Controller.6eb2aaac.png";